import { useEffect } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 香蕉影视';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://banana-tv.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '香蕉影视需要付费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！香蕉影视所有剧集全部免费观看，无需注册会员，无需任何付费，打开即可畅享高清追剧体验。',
                },
              },
              {
                '@type': 'Question',
                name: '香蕉影视支持哪些设备观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '香蕉影视支持电脑、平板、手机等多种设备，只要打开浏览器即可在线观看，无需下载任何APP。',
                },
              },
              {
                '@type': 'Question',
                name: '香蕉影视更新速度快吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '香蕉影视拥有专业的更新团队，热门剧集每日准时更新，同步各大平台最新剧集，让你追剧快人一步。',
                },
              },
            ],
          }),
        }}
      />

      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-6">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <div className="mb-10">
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
            关于香蕉影视
          </h1>
          <p className="text-sm text-foreground-500 max-w-2xl">
            香蕉影视致力于为广大追剧爱好者提供最新、最全、最流畅的在线追剧体验
          </p>
        </div>

        <section className="mb-12">
          <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4">
            品牌介绍
          </h2>
          <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              香蕉影视成立于2020年，是一家专注于提供高清在线视频播放服务的平台。我们深知追剧爱好者的需求——<strong>画质要清晰、播放要流畅、更新要及时</strong>，正是在这样的理念驱动下，香蕉影视应运而生。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              经过多年的发展，香蕉影视已经积累了<strong>海量的电视剧资源</strong>，涵盖国产剧、韩剧、美剧、日剧、综艺、动漫等多种类型。无论你喜欢哪种风格的剧集，都能在香蕉影视找到心仪的内容。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed">
              我们的技术团队持续优化播放体验，采用先进的视频压缩和CDN加速技术，确保用户<strong>不缓冲、不卡顿</strong>，随时随地享受流畅的追剧体验。同时，我们坚持<strong>全集免费</strong>的原则，让每一位用户都能无门槛地享受高品质的影视内容。
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {[
              {
                name: '追剧达人小王',
                text: '用了香蕉影视两年多了，资源真的很全！国产剧韩剧都有，更新速度也快，追剧必备！',
                rating: 5,
              },
              {
                name: '影视爱好者小李',
                text: '播放流畅不卡顿是我最喜欢的点，不像有些平台看几分钟就缓冲。画质也很清晰，好评！',
                rating: 5,
              },
              {
                name: '剧荒终结者',
                text: '分类很清晰，推荐也很精准。通过香蕉影视我发现了不少好剧，现在每天必刷！',
                rating: 5,
              },
              {
                name: '夜猫子追剧人',
                text: '深夜追剧也不卡，体验太好了。而且免费无广告，真的是良心平台！',
                rating: 5,
              },
              {
                name: '美剧狂热粉',
                text: '美剧资源很丰富，经典剧集全集都有。字幕翻译质量也不错，强烈推荐给美剧爱好者。',
                rating: 4,
              },
              {
                name: '日剧宅女',
                text: '日剧分类做得很好，经典老剧和最新番剧都有。从此再也不用到处找资源了！',
                rating: 5,
              },
            ].map((review, idx) => (
              <div
                key={idx}
                className="p-5 rounded-lg bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${
                        i < review.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  &ldquo;{review.text}&rdquo;
                </p>
                <p className="text-xs font-medium text-foreground-500">
                  — {review.name}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4">
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              {
                q: '香蕉影视需要付费吗？',
                a: '完全不需要！香蕉影视所有剧集全部免费观看，无需注册会员，无需任何付费，打开即可畅享高清追剧体验。',
              },
              {
                q: '香蕉影视支持哪些设备观看？',
                a: '香蕉影视支持电脑、平板、手机等多种设备，只要打开浏览器即可在线观看，无需下载任何APP。适配所有主流浏览器，随时随地追剧无忧。',
              },
              {
                q: '香蕉影视的更新速度如何？',
                a: '香蕉影视拥有专业的更新团队，热门剧集每日准时更新，同步各大平台最新剧集。热播剧通常在播出后数小时内即可上线，让你追剧快人一步。',
              },
              {
                q: '播放卡顿怎么办？',
                a: '香蕉影视采用先进的CDN加速技术，正常情况下播放流畅不卡顿。如遇卡顿，可尝试切换清晰度或刷新页面。也请确保您的网络连接稳定。',
              },
              {
                q: '如何找到想看的剧集？',
                a: '您可以通过首页的分类导航浏览不同类别的剧集，也可以使用搜索功能（即将上线）快速查找。热门推荐和最新更新板块也能帮您发现好剧。',
              },
            ].map((faq, idx) => (
              <details
                key={idx}
                className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between p-4 text-sm font-semibold text-foreground-800 hover:text-primary-500 transition-colors duration-200">
                  {faq.q}
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </section>

        <section>
          <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4">
            联系我们
          </h2>
          <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@banana-tv.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                  <i className="ri-customer-service-2-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">客服热线</h3>
                  <p className="text-sm text-foreground-500">400-888-8888</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">公司地址</h3>
                  <p className="text-sm text-foreground-500">北京市朝阳区影视产业园区A座</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}